/* ============================================
   DomyRugs — Tracker de commande
   Fichier : assets/domyrugs-tracker.js
   
   Fonctionnement :
   - Lit l'URL : ?order=1234&token=abc
   - Appelle l'API Shopify pour récupérer la commande
   - Lit les tags de la commande pour déterminer l'étape
   - Affiche la bonne étape dans l'UI
   
   Tags Shopify à utiliser sur les commandes :
     "en-attente"    → étape 0
     "en-production" → étape 1  (défaut si aucun tag)
     "finitions"     → étape 2
     "expedie"       → étape 3
   ============================================ */

(function () {
  'use strict';

  // ---- Configuration des étapes ----
  const STEPS = [
    {
      tag:    'en-attente',
      icon:   '⏳',
      label:  'En attente',
      desc:   "Commande reçue et confirmée. Nos artisans vont bientôt s'en occuper !",
      tagTxt: 'Reçue',
      fill:   '0%',
      eta:    'Lancement imminent'
    },
    {
      tag:    'en-production',
      icon:   '🧶',
      label:  'En cours de production',
      desc:   'Nos artisans travaillent sur ton tapis ! Entre 7 et 14 jours selon la complexité du motif.',
      tagTxt: 'En cours ✨',
      fill:   '30%',
      eta:    'Livraison estimée sous 3 semaines'
    },
    {
      tag:    'finitions',
      icon:   '✂️',
      label:  'Rasage et finitions',
      desc:   'Rasage, découpe et finitions pour un rendu impeccable.',
      tagTxt: 'En cours ✨',
      fill:   '65%',
      eta:    'Livraison estimée sous 1 semaine'
    },
    {
      tag:    'expedie',
      icon:   '📦',
      label:  'Expédié',
      desc:   'Ton tapis est en route ! Tu recevras un email avec le numéro de suivi.',
      tagTxt: 'Expédié 🎉',
      fill:   '100%',
      eta:    'En route ! 🎉'
    }
  ];

  // ---- Initialisation ----
  document.addEventListener('DOMContentLoaded', function () {
    const params   = new URLSearchParams(window.location.search);
    const orderNum = params.get('order');
    const token    = params.get('token');

    const chipEl = document.getElementById('dr-order-chip');

    if (!orderNum || !token) {
      showError();
      chipEl.textContent = 'Commande introuvable';
      return;
    }

    chipEl.textContent = 'Commande #' + orderNum;
    loadOrder(orderNum, token);
  });

  // ---- Chargement de la commande via API Shopify ----
  function loadOrder(orderNum, token) {
    // L'API /api/2024-01/orders.json filtrée par name + token
    // Fonctionne côté client grâce au token unique de commande Shopify
    fetch('/api/2024-01/orders.json?name=%23' + encodeURIComponent(orderNum) + '&status=any', {
      headers: {
        'Content-Type': 'application/json'
      }
    })
    .then(function (res) { return res.json(); })
    .then(function (data) {
      if (!data.orders || data.orders.length === 0) {
        showError();
        return;
      }

      // Vérifie le token pour sécuriser l'accès
      var order = data.orders.find(function (o) {
        return o.token === token;
      });

      if (!order) {
        showError();
        return;
      }

      renderOrder(order);
    })
    .catch(function () {
      showError();
    });
  }

  // ---- Rendu de la commande ----
  function renderOrder(order) {
    // Récupère les tags de la commande (ex: "en-production, custom")
    var tags = (order.tags || '').toLowerCase().split(',').map(function (t) {
      return t.trim();
    });

    // Détermine l'étape active selon les tags
    var activeStep = 0;
    for (var i = STEPS.length - 1; i >= 0; i--) {
      if (tags.indexOf(STEPS[i].tag) !== -1) {
        activeStep = i;
        break;
      }
    }

    // Nom du produit
    var productName = '—';
    if (order.line_items && order.line_items.length > 0) {
      productName = order.line_items[0].name;
    }

    // Date de commande formatée
    var orderDate = formatDate(order.created_at);

    // Affiche la carte info
    document.getElementById('dr-product-name').textContent = productName;
    document.getElementById('dr-order-date').textContent   = 'Passée le ' + orderDate;
    document.getElementById('dr-eta-pill').textContent     = STEPS[activeStep].eta;
    document.getElementById('dr-info-card').style.display  = 'flex';

    // Affiche le tracker
    document.getElementById('dr-tracker').style.display = 'block';

    // Met à jour les étapes
    renderSteps(activeStep, order);
  }

  // ---- Rendu des étapes ----
  function renderSteps(activeStep, order) {
    document.getElementById('dr-vert-fill').style.height = STEPS[activeStep].fill;

    for (var i = 0; i < STEPS.length; i++) {
      var dot  = document.getElementById('dr-dot-'  + i);
      var card = document.getElementById('dr-card-' + i);
      var tag  = document.getElementById('dr-tag-'  + i);
      var date = document.getElementById('dr-date-' + i);
      var name = card.querySelector('.dr-step-name');
      var desc = card.querySelector('.dr-step-desc');

      if (i < activeStep) {
        // Étape passée
        dot.className  = 'dr-dot done';
        dot.textContent = '✓';
        card.className = 'dr-card done';
        name.className = 'dr-step-name';
        tag.className  = 'dr-tag done';
        tag.textContent = 'Terminé';
        desc.className = 'dr-step-desc';
        date.textContent = getStepDate(order, i);

      } else if (i === activeStep) {
        // Étape active
        dot.className  = 'dr-dot active';
        dot.textContent = STEPS[i].icon;
        card.className = 'dr-card active';
        name.className = 'dr-step-name';
        tag.className  = 'dr-tag active';
        tag.textContent = STEPS[i].tagTxt;
        desc.className = 'dr-step-desc';
        date.textContent = getStepDate(order, i);

      } else {
        // Étape à venir
        dot.className  = 'dr-dot';
        dot.textContent = STEPS[i].icon;
        card.className = 'dr-card';
        name.className = 'dr-step-name pending';
        tag.className  = 'dr-tag pending';
        tag.textContent = 'À venir';
        desc.className = 'dr-step-desc pending';
        date.textContent = '';
      }
    }
  }

  // ---- Récupère la date d'une étape depuis les notes ou la date de commande ----
  function getStepDate(order, stepIndex) {
    // Étape 0 = date de commande
    if (stepIndex === 0) {
      return 'Le ' + formatDate(order.created_at);
    }
    // Étape 3 = date d'expédition si disponible
    if (stepIndex === 3 && order.fulfillments && order.fulfillments.length > 0) {
      return 'Le ' + formatDate(order.fulfillments[0].created_at);
    }
    // Pour les étapes intermédiaires, cherche dans note_attributes
    // Tu peux ajouter des attributs "date-production", "date-finitions" depuis ton admin
    var attrName = ['', 'date-production', 'date-finitions', ''][stepIndex];
    if (attrName && order.note_attributes) {
      var attr = order.note_attributes.find(function (a) { return a.name === attrName; });
      if (attr) return 'Depuis le ' + attr.value;
    }
    return '';
  }

  // ---- Affichage erreur ----
  function showError() {
    document.getElementById('dr-error').style.display  = 'block';
    document.getElementById('dr-tracker').style.display = 'none';
    document.getElementById('dr-info-card').style.display = 'none';
  }

  // ---- Formatage date ---- 
  function formatDate(isoString) {
    if (!isoString) return '—';
    var d = new Date(isoString);
    var months = ['janvier','février','mars','avril','mai','juin','juillet','août','septembre','octobre','novembre','décembre'];
    return d.getDate() + ' ' + months[d.getMonth()] + ' ' + d.getFullYear();
  }

})();
